module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.editEvent ? 'Rediger' : 'Opret') + " vagt til " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-group"
  }, [_c('div', {
    staticClass: "time-changer__group"
  }, [_c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer",
    class: {
      'do-modal__footer--flex': _vm.editEvent
    }
  }, [(_vm.editEvent) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.onDelete
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.editEvent) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmitEditEvent
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.update')) + "\n        ")]) : [(!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n          ")])]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b87a766!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/CreateEvent/CreateEventForm.vue
// module id = 1452
// module chunks = 1